export const Loyaltic = {
    API: {
        RegisterWithMobile: 'api/v1/user/RegisterWithMobile',
        RegisterWithEmail: 'api/v1/user/registerwithemail',
        LiveConfig: 'api/v1/liveconfig',
        CaptureEmail: 'api/v1/capturereminderemail',
        UserExists: 'api/v1/user/userexists',
        NicknameExists: 'api/v1/user/nicknameexists',
        CaptureNickName: 'api/v1/user/capturenickname',
        AvailableGames: 'api/v1/user/availablegames',
        Play: 'api/v1/user/play',
        InstantWinPlay: 'api/v1/instantwinplay',
        CaptureAddress: 'api/v1/captureaddress',
        CaptureDigitalWin: 'api/v1/capturedigitalwin',
        SubmitCashback: 'api/v1/submitcashback',
        Ranking: 'api/v1/fetchRanking',
        CombinedRanking: 'api/v1/fetchCombinedRanking',
        FbShareSuccess: 'api/v1/user/fbsharebonuspoints',
        LocalizationByCulture: 'api/v1/LocalizationByCulture',
        LocalizationByPage: 'api/v1/LocalizationByPage',
        CreateTournament: 'api/v1/createTournament',
        GetTournamenrs: 'api/v1/getTournaments',
        GetStores: 'api/v1/storeList',
        SendFeedback: '/api/v1/sendfeedback',
        JoinTournament: 'api/v1/joinTournament',
        CaptureImage: 'api/v1/user/uploadavatar',
        Winners: 'api/v1/winners',
        Address: 'api/v1/address',
        GetTournamentDetails: 'api/v1/getTournamentUserDetails',
        DeleteTournament: 'api/v1/deleteTournament',
        RemoveUserFromTournament: 'api/v1/removeUserFromTournament',
        ForgotPassword: 'api/v1/forgotpassword',
        ResetPassword: 'api/v1/resetpassword',
        LeaveTournament: 'api/v1/leaveTournament',
        Report: {
            Registrations: 'api/report/registrations',
            Games: 'api/report/games',
            MarketingOptins: 'api/report/marketing-optins',
            MarketingOptinsExport: 'api/report/marketing-optins/export',
            OptinRate: 'api/report/optin-rate',
            Rewards: 'api/report/rewards',
        },
        Localization: {
            Controller: 'Admin/',
            Actions: {
                LocalizationByPage: 'LocalizationByPage',
                AddNewGlobalLocalization: 'AddNewGlobalLocalization',
                UpdateGlobalLocalization: 'UpdateGlobalLocalization',
                LocalizationByCulture: 'LocalizationByCulture',
            }
        }
    }
};
